<template>
  <div id="history">
    <sHeader :activeIndex="1" />

    <div class="page-content videos">
      <template v-for="(item, index) in videos">
        <VideoItem :data="item" :key="index" />
      </template>
    </div>
  </div>
</template>

<script>
import sHeader from '@/components/templates/sHeader'
import VideoItem from '@/components/templates/VideoItem'

export default {
  components: {
    sHeader,
    VideoItem
  },
  mounted () {
    this.$ajax.get('interface.php?media=1&type=mongol')
      .then((res) => {
        // console.log(res.data.videos)
        this.videos = res.data.videos
      })
  },
  methods: {
  },
  data () {
    return {
      videos: []
    }
  }
}
</script>

<style lang="stylus" scoped>
  </style>



// WEBPACK FOOTER //
// src/components/MongolHistory.vue